// @flow

import { type Address } from './types';

export function getCity(address: Address): string {
  return address['city'] || '';
}
